@if (operation) {
<tec-collapse
    [icon]="isAttorneyPowersEvaluation ? 'icon-shield-check' : 'icon-coin'"
    [title]="(isAttorneyPowersEvaluation ? 'WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS' : 'PROCESSES.DETAIL.FINANCIAL_EVALUATION') | translate"
    [tags]="operation.state ? [
        {
            label: ('MASTER.STATUS.' + operation.state | translate),
            status: masterService.getTagStatus(operation.state)
        }
    ] :  undefined"
    [expanded]="expanded"
    (clickEvent)="toggleCollapse?.emit($event)"
>
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath"
        titleKey="PROCESSES.CURL_MODAL.TITLE_OPERATION"
    />
    @if (loading) {
        <tec-tile [type]="'loading'" [title]="'LOADING.PROCESS_DETAIL' | translate" />
    } @else {
        @if (!isAttorneyPowersEvaluation && operation.evaluation === EVALUATION_TYPE.SCORING) {
            <tec-stats
                [title]="operation?.scoring?.toString() || ('GENERAL.NOT_AVAILABLE' | translate)"
                [description]="'PROCESSES.DETAIL.SCORING' | translate"
            />
        }

        @if (isAttorneyPowersEvaluation && lastScriptureDocument; as doc) {
        <tec-tile [title]="'PROCESSES.DETAIL.DETAILS' | translate">
                <tec-item
                    [tagImage]="{ icon: 'icon-briefcase', status: 'control' }"
                    [title]="'DOCS.SCRIPTURE' | translate"
                    clickeable="false"
                >
                    @if (doc?.state) {
                        <tec-tag
                            [label]="('MASTER.STATUS.' + doc.state | translate)"
                            [status]="masterService.getTagStatusDoc(doc.state)"
                        />
                    }
                    <tec-list-detail>
                        <tec-info-group>
                            <span>{{ 'PROCESSES.DETAIL.NUM_TRIED' | translate }}</span>
                            <tec-badge [label]="doc?.total_tries?.toString() ?? ('GENERAL.NOT_AVAILABLE' | translate)" type="square" />
                            @if (doc?.state === DocStatus.KO) {
                            <tec-tag-icon size="sm" [icon]="'icon-alert'" />
                            }
                        </tec-info-group>
                    </tec-list-detail>
                    <tec-button-icon icon="icon-eye" (click)="openDocument(doc?.url)" />
                </tec-item>
        </tec-tile>
        }

        <tec-tile [title]="'PROCESSES.DETAIL.OPERATION' | translate">
            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.ID_OPERATION' | translate">
                    <!-- Comentado hasta que tengamos el detalle de la operación
                    <span>{{ processHelper.truncateUUID(operation.uuid) ?? ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                    <tec-button-icon icon="icon-eye" size="sm" (click)="goToOperation(operation.uuid)" /> -->
                    <tec-copy-text
                        [label]="processHelper.truncateUUID(operation.uuid)"
                        [labelToCopy]="operation.uuid"
                    ></tec-copy-text>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.TYPE' | translate">
                    <span>{{ ('FINANCIAL_EVALUATION.' + operation.type) | translate }}</span>
                </tec-info-group>
                @if (!isAttorneyPowersEvaluation) {
                <tec-info-group [label]="'PROCESSES.DETAIL.FINANCIAL_EVALUATION_TYPE' | translate">
                    <span>{{ operation.evaluation === EVALUATION_TYPE.SCORING ? ('PROCESSES.DETAIL.FINANCIAL_EVALUATION_OPTION' | translate) : ('PROCESSES.DETAIL.VERIFY_IDENTITY' | translate) }}</span>
                </tec-info-group>
                }
                <tec-info-group [label]="'PROCESSES.DETAIL.OBTAIN_METHOD' | translate">
                    <tec-tag [label]=" ('PROCESSES.DETAIL.' + (operation.mode === 'auto' ? 'AUTOMATIC' : 'MANUAL')) | translate" />
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.NUM_TRIED' | translate">
                    <tec-badge [label]="(operation.total_tries === 0 ? '1' : operation.total_tries?.toString()) ?? ('GENERAL.NOT_AVAILABLE' | translate)" type="square" />
                    @if (operation.state === OPERATION_STATUS.KO) {
                    <tec-tag-icon size="sm" [icon]="'icon-alert'" />
                    }
                </tec-info-group>
            </div>

            <tec-divider />

            <div class="grid grid-i3">
                <tec-info-group [label]="'PROCESSES.DETAIL.START_DATE' | translate">
                    <tec-icon name="icon-calendar" size="xs" />
                    <span>{{ formatDate(operation.start_at) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.END_DATE' | translate">
                    <tec-icon name="icon-calendar" size="xs" />
                    <span>{{ formatDate(operation.end_at) }}</span>
                </tec-info-group>
                <tec-info-group [label]="'PROCESSES.DETAIL.DURATION' | translate">
                    <tec-icon name="icon-clock" size="xs" />
                    <span>{{ formatDuration(operation.total_time) }}</span>
                </tec-info-group>
            </div>
        </tec-tile>

        <tec-button
            [label]="'PROCESSES.DETAIL.SEE_OPERATION' | translate"
            (clickEvent)="goToOperationDetail(operation.uuid, $event)"
        />
    }
</tec-collapse>
}
